import { render } from "./EducacionPublic.vue?vue&type=template&id=28166210"
import script from "./EducacionPublic.vue?vue&type=script&lang=js"
export * from "./EducacionPublic.vue?vue&type=script&lang=js"

import "./EducacionPublic.vue?vue&type=style&index=0&id=28166210&lang=scss"

import exportComponent from "G:\\desarrollo\\frontend\\gsobservatorio-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__